import React, { useState } from 'react';

const API_URL = '/.netlify/functions/public-derogation';

const S = {
  page: { fontFamily: "'DM Sans', 'Segoe UI', system-ui, sans-serif", maxWidth: 480, margin: '0 auto', padding: '16px', minHeight: '100dvh', background: '#F8F9FB' },
  header: { textAlign: 'center', marginBottom: 18, paddingTop: 12 },
  logo: { fontSize: 18, fontWeight: 700, color: '#1A5276', letterSpacing: -0.5 },
  sub: { fontSize: 12, color: '#6B7280', marginTop: 4 },
  card: { background: 'white', borderRadius: 12, border: '1px solid #E5E7EB', padding: '14px', marginBottom: 10 },
  lbl: { fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block' },
  req: { color: '#C0392B' },
  input: { width: '100%', padding: '11px 13px', borderRadius: 10, border: '1.5px solid #D6E4F0', fontSize: 15, fontFamily: 'inherit', boxSizing: 'border-box', outline: 'none' },
  area: { width: '100%', padding: '11px 13px', borderRadius: 10, border: '1.5px solid #D6E4F0', fontSize: 15, fontFamily: 'inherit', boxSizing: 'border-box', outline: 'none', minHeight: 76, resize: 'vertical' },
  row2: { display: 'flex', gap: 8 },
  pri: { width: '100%', padding: 15, borderRadius: 10, border: 'none', background: '#1A5276', color: 'white', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' },
  dis: { width: '100%', padding: 15, borderRadius: 10, border: 'none', background: '#E5E7EB', color: '#9CA3AF', fontSize: 15, fontWeight: 700, fontFamily: 'inherit', cursor: 'default' },
  pill: (active, color) => ({ flex: 1, padding: '11px 8px', borderRadius: 10, border: '1.5px solid ' + (active ? (color || '#1A5276') : '#E5E7EB'), background: active ? (color ? color : '#1A5276') : 'white', color: active ? 'white' : '#555', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'center' }),
  opt: (active) => ({ width: '100%', padding: '11px 13px', borderRadius: 10, border: '1.5px solid ' + (active ? '#1A5276' : '#E5E7EB'), background: active ? '#EEF6FF' : 'white', color: active ? '#1A5276' : '#444', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left', marginBottom: 6 }),
  check: (active, danger) => ({ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '12px', borderRadius: 10, border: '1.5px solid ' + (active ? (danger ? '#1E6B3C' : '#1E6B3C') : '#E5E7EB'), background: active ? '#EAF6EE' : 'white', cursor: 'pointer', marginBottom: 8 }),
  box: (active) => ({ width: 22, height: 22, borderRadius: 6, border: '1.5px solid ' + (active ? '#1E6B3C' : '#C9CDD3'), background: active ? '#1E6B3C' : 'white', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, flexShrink: 0 }),
};

const MOTIFS = [
  { value: 'rupture_patient', label: 'Rupture pour un patient' },
  { value: 'depannage', label: 'Depannage' },
  { value: 'indispo_ailleurs', label: 'Produit indisponible ailleurs' },
  { value: 'autre', label: 'Autre' },
];

function todayISO() {
  const d = new Date();
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

export default function DerogationForm() {
  const [f, setF] = useState({
    officine_nom: '', ville: '', code_postal: '', titulaire: '',
    date_commande: todayISO(), reference_commande: '', plateforme: '',
    produits: '', motif_urgence: '', motif_precision: '',
    repartiteur_precision: '', repartiteur_contacte: '',
  });
  const [repConfirme, setRepConfirme] = useState(false);
  const [attestation, setAttestation] = useState(false);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(null);
  const [err, setErr] = useState('');

  const set = (k) => (e) => setF(prev => ({ ...prev, [k]: e.target.value }));

  const valide = f.officine_nom.trim() && f.titulaire.trim() && f.date_commande
    && f.plateforme && f.produits.trim() && f.motif_urgence
    && repConfirme && attestation;

  async function envoyer() {
    if (!valide || sending) return;
    setSending(true); setErr('');
    try {
      const res = await fetch(API_URL, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'submit', params: {
          ...f, repartiteur_confirme: true, attestation: true,
        }}),
      });
      if (res.status === 429) throw new Error('Trop de demandes envoyees. Patientez une minute.');
      const json = await res.json();
      if (json.error) throw new Error(json.error);
      setDone(json.result);
    } catch (e) {
      setErr(e.message || 'Erreur lors de l\u2019envoi.');
    } finally {
      setSending(false);
    }
  }

  if (done) {
    const ref = 'DLS-' + String(done.id).padStart(5, '0');
    return (
      <div style={S.page}>
        <div style={S.header}><div style={S.logo}>ELIXIR PHARMA</div></div>
        <div style={{ ...S.card, textAlign: 'center', padding: 24 }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#D5F5E3', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28 }}>{'\u2713'}</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#1A1D23', marginBottom: 8 }}>Demande enregistree</div>
          <div style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.5 }}>Votre demande de livraison hors secteur a bien ete transmise a Elixir Pharma.</div>
          <div style={{ marginTop: 16, padding: 12, borderRadius: 10, background: '#F4ECDD', border: '1px solid #E5D6B8' }}>
            <div style={{ fontSize: 11, color: '#92710C', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Reference</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#1A2322', fontFamily: 'monospace', marginTop: 2 }}>{ref}</div>
          </div>
          <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 14 }}>Conservez cette reference. Pour une autre commande, remplissez un nouveau formulaire.</div>
        </div>
      </div>
    );
  }

  return (
    <div style={S.page}>
      <div style={S.header}>
        <div style={S.logo}>ELIXIR PHARMA</div>
        <div style={S.sub}>Demande de livraison hors secteur de repartition</div>
      </div>

      <div style={{ ...S.card, background: '#EEF6FF', border: '1.5px solid #BFDBFE' }}>
        <div style={{ fontSize: 13, color: '#1A5276', lineHeight: 1.5 }}>
          Ce formulaire permet de justifier une commande urgente lorsque votre officine se situe hors de notre secteur habituel de repartition. Merci de le remplir a chaque commande concernee (1 a 2 minutes).
        </div>
      </div>

      {/* Officine */}
      <div style={S.card}>
        <label style={S.lbl}>Nom de l{'\u2019'}officine <span style={S.req}>*</span></label>
        <input style={S.input} value={f.officine_nom} onChange={set('officine_nom')} placeholder="Pharmacie ..." />
        <div style={{ ...S.row2, marginTop: 10 }}>
          <div style={{ flex: 2 }}>
            <label style={S.lbl}>Ville</label>
            <input style={S.input} value={f.ville} onChange={set('ville')} placeholder="Ville" />
          </div>
          <div style={{ flex: 1 }}>
            <label style={S.lbl}>Code postal</label>
            <input style={S.input} value={f.code_postal} onChange={set('code_postal')} placeholder="00000" inputMode="numeric" />
          </div>
        </div>
        <div style={{ marginTop: 10 }}>
          <label style={S.lbl}>Titulaire / pharmacien responsable <span style={S.req}>*</span></label>
          <input style={S.input} value={f.titulaire} onChange={set('titulaire')} placeholder="Nom et prenom" />
        </div>
      </div>

      {/* Commande */}
      <div style={S.card}>
        <div style={S.row2}>
          <div style={{ flex: 1 }}>
            <label style={S.lbl}>Date de la commande <span style={S.req}>*</span></label>
            <input type="date" style={S.input} value={f.date_commande} onChange={set('date_commande')} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={S.lbl}>Reference / n{'\u00b0'} commande</label>
            <input style={S.input} value={f.reference_commande} onChange={set('reference_commande')} placeholder="Si disponible" />
          </div>
        </div>
        <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 4 }}>Le numero n{'\u2019'}est pas toujours connu au moment de la commande : laissez vide si besoin.</div>
        <div style={{ marginTop: 12 }}>
          <label style={S.lbl}>Plateforme de commande <span style={S.req}>*</span></label>
          <div style={S.row2}>
            <button onClick={() => setF(p => ({ ...p, plateforme: 'pharmaml' }))} style={S.pill(f.plateforme === 'pharmaml')}>PharmaML</button>
            <button onClick={() => setF(p => ({ ...p, plateforme: 'expepharma' }))} style={S.pill(f.plateforme === 'expepharma')}>Expepharma</button>
          </div>
        </div>
      </div>

      {/* Produits */}
      <div style={S.card}>
        <label style={S.lbl}>Produits concernes <span style={S.req}>*</span></label>
        <textarea style={S.area} value={f.produits} onChange={set('produits')} placeholder="Listez les produits (nom, CIP, quantite)..." />
      </div>

      {/* Motif urgence */}
      <div style={S.card}>
        <label style={S.lbl}>Motif de l{'\u2019'}urgence <span style={S.req}>*</span></label>
        {MOTIFS.map(m => (
          <button key={m.value} onClick={() => setF(p => ({ ...p, motif_urgence: m.value }))} style={S.opt(f.motif_urgence === m.value)}>
            {f.motif_urgence === m.value ? '\u25c9 ' : '\u25cb '}{m.label}
          </button>
        ))}
        {f.motif_urgence === 'autre' && (
          <input style={{ ...S.input, marginTop: 4 }} value={f.motif_precision} onChange={set('motif_precision')} placeholder="Precisez le motif" />
        )}
      </div>

      {/* Repartiteur */}
      <div style={S.card}>
        <label style={S.lbl}>Approvisionnement aupres du repartiteur habituel</label>
        <div onClick={() => setRepConfirme(v => !v)} style={S.check(repConfirme)}>
          <div style={S.box(repConfirme)}>{repConfirme ? '\u2713' : ''}</div>
          <div style={{ fontSize: 13, color: '#1A1D23', lineHeight: 1.4 }}>
            Je confirme ne pas avoir pu m{'\u2019'}approvisionner aupres de mon repartiteur habituel pour ces produits. <span style={S.req}>*</span>
          </div>
        </div>
        <input style={{ ...S.input, marginBottom: 8 }} value={f.repartiteur_contacte} onChange={set('repartiteur_contacte')} placeholder="Nom du repartiteur contacte (optionnel)" />
        <input style={S.input} value={f.repartiteur_precision} onChange={set('repartiteur_precision')} placeholder="Precision (optionnel) : reponse obtenue, rupture annoncee..." />
      </div>

      {/* Attestation */}
      <div style={S.card}>
        <div onClick={() => setAttestation(v => !v)} style={S.check(attestation)}>
          <div style={S.box(attestation)}>{attestation ? '\u2713' : ''}</div>
          <div style={{ fontSize: 13, color: '#1A1D23', lineHeight: 1.4 }}>
            J{'\u2019'}atteste sur l{'\u2019'}honneur que cette demande presente un caractere exceptionnel et que la commande est urgente. <span style={S.req}>*</span>
          </div>
        </div>
      </div>

      {err && <div style={{ ...S.card, background: '#FDECEA', border: '1.5px solid #C0392B', color: '#C0392B', fontSize: 13 }}>{err}</div>}

      <button onClick={envoyer} disabled={!valide || sending} style={valide && !sending ? S.pri : S.dis}>
        {sending ? 'Envoi...' : 'Envoyer la demande'}
      </button>
      <div style={{ fontSize: 11, color: '#9CA3AF', textAlign: 'center', margin: '12px 0 24px' }}>
        Elixir Pharma SAS {'\u00b7'} Donnees traitees pour la tracabilite reglementaire de la commande.
      </div>
    </div>
  );
}
